import React, { useMemo } from 'react';

// DEPENDENCIES
import isEmpty from 'lodash/isEmpty';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL HELPERS
import useLookup from 'helpers/useLookup';
import { useFormikContext } from 'formik';

// GLOBAL FUNCTIONS
import { checkRole } from 'functions.js';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';
import Record from 'parts/record/Record';

// MAIN COMPONENT
const AddDealerForm = () => (
  <Record.Update
    recordLabel="dealer form"
    endpoints={ENDPOINTS.admin.dealerForm}
    initialValues={{
      is_active: 1,
      is_global: 0
    }}
  >
    <Card body={<FormBody />} />
  </Record.Update>
);

const FormBody = () => {
  // HOOKS
  const { lookup: storesByDealerGroup = [] } = useLookup({ lookup: 'storesByDealerGroup' });

  // CONTEXT
  const { values } = useFormikContext() || {};
  const { is_global } = values || {};

  // MEMOS
  const isAdmin = useMemo(() => checkRole(['dslAdmin']), []);

  return (
    <Form.Body>
      <Form.YesNo name="is_active" label="Active" />
      <Form.Control name="form_department" label="Department" required />
      <Form.Control name="form_name" label="Form Name" required />
      <Form.Textarea name="form_description" label="Form Description" required />
      <Form.Control name="form_instructions_url" label="Form Instructions Url" />
      <Form.Control name="form_link_url" label="Form Link Url" required />
      {isAdmin && <Form.YesNo name="is_global" label="Global" />}
      {(!parseInt(is_global) || !isAdmin) && !isEmpty(values) && (
        <Form.Checklist.Large
          name="make_dealer_id"
          label="Store"
          toggleAll
          options={storesByDealerGroup.map(({ make_dealer_id, dealer_name }) => ({
            label: dealer_name,
            value: make_dealer_id
          }))}
          required
          useCSV
          useNone
        />
      )}
      <Record.Log />
    </Form.Body>
  );
};

// EXPORT
export default AddDealerForm;
